/* eslint-disable @typescript-eslint/no-explicit-any */
import { RoutesType } from '../config';
import { useRouting, UseRouting } from './routing.hook';

/**
 *
 * @param targetRoute the route you want to navigate to
 * @returns A function that executes the navigation, taking params if necessary
 */
export function useRoutePush<Target extends keyof RoutesType>(
  targetRoute: Target,
): UseRouting[Target] {
  const routing = useRouting();

  return routing[targetRoute];
}
